import React, { Component } from 'react';
import { Form, Modal, InputNumber, DatePicker, Select } from 'antd';
import moment from 'moment';

const FormItem = Form.Item;
const { Option } = Select;
const { RangePicker } = DatePicker;

class FormImportWage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOk = () => {
    const {
      handleSubmit,
      form: { validateFields },
    } = this.props;
    validateFields((err, values) => {
      if (!err) {
        values.beginDate = moment(values.range[0]).valueOf();
        values.endDate = moment(values.range[1]).valueOf();
        values.date = moment(values.date).valueOf();
        delete values.range;
        handleSubmit(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    return (
      <Modal title="添加付款约定" onOk={this.handleOk} onCancel={this.props.onCancel} visible>
        <Form>
          <FormItem label="收入类型">
            {getFieldDecorator('type', {
              rules: [{ required: true, message: '请选择收入类型' }],
              initialValue: data ? `${data.type}` : '',
            })(
              <Select>
                <Option key="0">押金</Option>
                <Option key="1">工位收入</Option>
                <Option key="2">地址收入</Option>
              </Select>,
            )}
          </FormItem>
          <FormItem label="合同租期">
            {getFieldDecorator('range', {
              rules: [{ required: true, message: '请选择合同起止时间' }],
              initialValue: data ? [moment(data.beginDate), moment(data.endDate)] : null,
            })(<RangePicker />)}
          </FormItem>
          <FormItem label="付款金额">
            {getFieldDecorator('price', {
              rules: [{ required: true, message: '请输入付款金额' }],
              initialValue: data ? data.price : '',
            })(<InputNumber />)}
          </FormItem>
          <FormItem label="付款时间">
            {getFieldDecorator('date', {
              rules: [{ required: true, message: '请选择付款时间' }],
              initialValue: data ? moment(data.date) : null,
            })(<DatePicker />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(FormImportWage);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/comm/ModalAppointAdd.js